<template>
  <div class="home home-page font_Montserrat">
    <div class="dashboard mb-5">
      <template v-if="questionnaire">
      <current-study-section
          v-if="!this.studyIsSubmitted && shouldRenderCurrentStudy"
          :questionnaire="questionnaire"
          :society="society"
          :user="user"
          :study="this.currentStudy"
          :isButtonTextBeginStudy="isButtonTextBeginStudy"
          @fill-user-profile="showUserProfilePopup"
      />
      </template>
      <p class="text-alignment-mobile">
        {{ informHeader }}
      </p>
      <info-section>
        <b-button
          slot="action-buttons"
          v-if="isStudyAvailable"
          variant="v3_teal_outline"
          class="mr-2 mb-2 mb-lg-0"
          :disabled="beginLoading"
          @click="onSetJobTerms"
        >
          <b-spinner v-if="beginLoading" small />
          <span v-else>Share Your Info</span>
        </b-button>
        <demographic />
        <template v-if="questionnaireLoading">
          <half-circle-spinner />
        </template>
        <key-measures
          v-else-if="questionnaire"
          :questionnaire="questionnaire"
        />
      </info-section>
      <connect-section>
        <b-button
          slot="action-buttons"
          v-if="isPvsStudyAvailable"
          variant="v3_teal_outline"
          class="mr-2 mb-2 mb-lg-0"
          @click="onSetJobTerms"
          :disabled="beginLoading"
        >
          <b-spinner v-if="beginLoading" small />
          <span v-else>Set Job Terms</span>
        </b-button>
        <connect-demographic />
      </connect-section>

      <!-- job preferences -->
      <div class="my-4" v-if="user && user.completedStudyWithJobPreferences">
        <job-profiles-list-v3 />
      </div>
    </div>
    <b-modal
      size="xl"
      :visible="isUserProfilePopupVisible"
      class="v3_modal"
      :header-class="'align-items-center border_0'"
      :body-class="'p-0'"
      hide-footer
      @hidden="isUserProfilePopupVisible = false"
    >
      <template slot="modal-header">
        <h2 class="font_size_1125rem">User Profile</h2>
        <div class="d-flex align-items-center justify-content-between">
          <b-button variant="v3_teal_outline" @click="onUserProfileSave">
            <template v-if="!userProfilePopupLoading">Save</template>
            <b-spinner v-else small />
          </b-button>
          <b-button
            variant="v3_red_outline"
            class="ml-3"
            @click="isUserProfilePopupVisible = false"
          >
            Cancel
          </b-button>
        </div>
      </template>
      <user-profile-form
        ref="userProfileModal"
        @profile-form-submit="onProfileSubmit"
        @profile-form-cancel="isUserProfilePopupVisible = false"
        @validate-failed="userProfilePopupLoading = false"
      />
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import CurrentStudySection from '@/components/dashboard/CurrentStudySection';
import InfoSection from '@/components/dashboard/InfoSection';
import UserProfileForm from '@/components/users/profile/UserProfileForm';
import ConnectSection from '@/components/dashboard/ConnectSection';
import Api from '@/providers/Api';
import { CREATE_SURVEY_ACTION } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';
import Demographic from '@/components/dashboard/metrics/Demographic';
import KeyMeasures from '@/components/dashboard/KeyMeasures';
import ConnectDemographic from '@/components/dashboard/metrics/ConnectDemographic';
import JobProfilesListV3 from '@/components/exchange/job-profiles-list/JobProfilesListV3';

export default {
  name: 'home',
  components: {
    CurrentStudySection,
    Demographic,
    InfoSection,
    KeyMeasures,
    UserProfileForm,
    ConnectSection,
    HalfCircleSpinner,
    ConnectDemographic,
    JobProfilesListV3,
  },
  props: {
    initialReferModalVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isUserProfilePopupVisible: false,
      userProfilePopupLoading: false,
      societyQuestionnaires: null,
      beginLoading: false,
      shouldRenderCurrentStudy: false,
      studyIsSubmitted : false,
      currentStudy: {}
    };
  },
  created: function () {
    this.getSocietyQuestionnaires();
    this.getQuestionnaire();
    setTimeout(() => {
      this.shouldRenderCurrentStudy = true;
    }, 5000);
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    questionnaire: function () {   
      return this.user && this.user.questionnaire
        ? this.user.questionnaire
        : null;
    },
    study: function () {      
      return this.questionnaire && this.questionnaire.survey
        ? this.questionnaire.survey
        : null;
    },
    isButtonTextBeginStudy: function () {
      if(this.user && this.user.questionnaire
      && this.user.questionnaire.prior_year_questionnaire_id
      && this.matchPriorQuetionnaire.length > 0
      ){
          return false;
      }
      return true;

      // return this.user && this.user.completed_surveys.length > 0
      //   ? true
      //   : false;
    },
    matchPriorQuetionnaire: function () {
      if(this.user.completed_surveys.length > 0){
        return this.user.completed_surveys.filter(
          survey => survey.questionnaire_id === this.user.questionnaire.prior_year_questionnaire_id
        );
      }
      return [];
    },
    society: function () {
      const user = this.$store.state.user;
      return user && user.society_id ? user.society : {};
    },
    societyName: function () {
      return this.society ? this.society.name : '';
    },
    isStudyAvailable: function () {
      return (
        this.questionnaire &&
        this.questionnaire.isActive &&
        !(this.study || {}).submitted
      );
    },
    isPvsStudyAvailable: function () {
      return (
        this.isStudyAvailable && this.questionnaire.is_support_job_preference
      );
    },
    questionnaireLoading: function () {
      return this.$store.state.userQuestionnaireLoading;
    },
    informHeader: function () {
      if (!this.user || !this.user.specialty) {
        return ``;
      }
      if (this.isSocietyLogoVisible) {
        const subspecialtyPart = this.user && this.user.subspecialty
          ? `/ Subspecialty: ${this.user.subspecialty.title}`
          : ``;
        return `Specialty: ${this.user.specialty.title} ${subspecialtyPart}`;
      }
      const specialtyString = this.user && this.user.subspecialty
        ? this.user.subspecialty.title
        : this.user.specialty.title;
      return `${specialtyString}`;
    },
    societyLogo: function () {
      return this.society && this.society.logo ? this.society.logo : null;
    },
    isSocietyLogoVisible: function () {
      return !!this.societyLogo && !this.$store.getters.userIsGMAdmin;
    },
    // studyIsSubmitted: function () {  
    //   console.log(this.study);    
    //   return this.study && this.study.submitted;
    // },   
  },
  methods: {
    showUserProfilePopup: function () {
      this.isUserProfilePopupVisible = true;
    },
    onUserProfileSave: function () {
      this.userProfilePopupLoading = true;
      this.$refs.userProfileModal &&
        typeof this.$refs.userProfileModal.save === 'function' &&
        this.$refs.userProfileModal.save();
    },
    onProfileSubmit: function () {
      this.userProfilePopupLoading = false;
      this.isUserProfilePopupVisible = false;
      this.beginStudy();
    },
    continueStudy: function () {
      this.$router.push(`/surveyForm/${this.study.id}`);
    },
    beginStudy: async function () {
      this.beginLoading = true;
      try {
        const isUserProfileFilled = await Api.isUserProfileFilled();
        if (!isUserProfileFilled) {
          this.showUserProfilePopup();
          return;
        }
        const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
          questionnaireId: this.questionnaire.id,
        });
        this.$router.push(`/surveyForm/${survey.id}`);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.beginLoading = false;
      }
    },
    onSetJobTerms: function () {
      this.study ? this.continueStudy() : this.beginStudy();
    },
    getSocietyQuestionnaires: async function () {
      this.societyQuestionnaires = await Api.getSocietyQuestionnaires(
        this.society.id
      );
    },
    getQuestionnaire: async function () {
      if (this.questionnaire || !this.user.questionnaire_id) {
        return;
      }
      const questionnaire = await Api.getQuestionnaireById(this.user.questionnaire_id);
      this.$set(this.user, 'questionnaire', questionnaire);
    },
  },
  watch: {
    study: {
    handler(newValue, oldValue) {
      const submittedInNewValue = newValue && newValue.submitted;
      const submittedInOldValue = oldValue && oldValue.submitted;
      if(newValue === null){
        this.currentStudy = oldValue;
      }else{
        this.currentStudy = newValue;
      }
      if (submittedInNewValue || submittedInOldValue) {
        this.studyIsSubmitted = true;
      }
    },
    immediate: true // This ensures that the handler is called immediately on component creation
  }
}
};
</script>

<style scoped>
@media (max-width:768px) {
  .text-alignment-mobile{
    text-align: center;
  }
  .home-page{
    margin:0 1rem;
  }
}

</style>
<style>
@media (max-width:485px){
  .small-mobie-screens{
    margin: unset;
  }
}
@media (max-width:485px) {
  .text-alignment-mobile{
    text-align: center;
  }
  .home-page{
    margin:0 1rem;
  }
}
</style>
